import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { StoresService } from '../../../core/routing/services/stores_api/stores.service';
import { Stores, StoresInterface, UserRole } from './interface/store.i';
import {
  StoresConstant,
  Enumvalues
} from '../../../core/routing/services/stores_api/constants/stores.constant';
import { storesCountriesConstants } from '../../../core/routing/services/stores_api/constants/stores-countries.constant';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { RetailService } from '../../../core/routing/services/retail_api/retail.service';
import { RetailHq } from '../interface/retail.i';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { Subject } from 'rxjs';
import { IPOSValidator } from '../../../common/validators/validators';
import { RetailStoreCommonConstants } from '../../../common/constants/retailer-store.constant';
import { ActiveUserConstants } from '../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { ActiveUsers } from '../active-users/interface/active-users.i';
import { ActiveusersService } from '../../../core/routing/services/activeusers_api/activeusers.service';
import { countryConstants } from '../../../core/routing/constants/country.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CommonService } from '../../../common/services/common.service';
import { first } from 'rxjs/internal/operators/first';
import { SSL_OP_NO_TLSv1_1 } from 'constants';

@Component({
  selector: 'iposcen-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss']
})

export class StoresComponent implements OnInit, OnDestroy {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('deleteMultiStoreModal') deleteMultiStoreModal: ElementRef;
  @ViewChild('deleteAckModal') deleteAckModal: ElementRef;
  @ViewChild('deleteMultiAckModal') deleteMultiAckModal: ElementRef;
  isLoading = false;
  isStoresTableEmpty: boolean = false;
  globalConst = GlobalConstants;
  retailStoreConst = RetailStoreCommonConstants;
  isEnglish = localStorage.getItem('preferredLanguage') === 'en-US'
  isGreek = localStorage.getItem('preferredLanguage') === 'el'
  storeForm: FormGroup;
  editForm: FormGroup;
  editFormArray: FormArray[] = [];
  storesData: Stores[] = [];
  countryList = [];
  stateProvinceRegions = [];
  hqRetailer = [];
  closeFilter: boolean;
  filterCountryList : string;
  filterString: string;
  selectFilterQueue = {};
  showCreatePopup: boolean;
  country: string;
  storeName: string;
  storeId: string;
  retailerID: string;
  retailerName: string;
  createdBy: string;
  storeNumber: string;
  customStoreId: string;
  stateregionProvince: string;
  address: string;
  postalCode: string;
  storeCode: string;
  tabIndex: number;
  isDesc = false;
  showStoresContainer: boolean;
  page: number;
  tableSize: number;
  searchTag: string;
  searchData: string;
  showFrom: number;
  showTo: number;
  globalSortValue: string;
  globalSortBy: string;
  isAscendingSort = false;
  loadFlag: string;
  expanded: boolean[] = [];
  isEditable: boolean[] = [];
  openModal = false;
  fileName: string;
  document: any = {};
  showcsvError = false;
  incorrectError = false;
  csvStore = [];
  file: any = {};
  importdata: any = {};
  storeCount: string;
  successPopup = false;
  valueForSearch: string;
  showEditSave: boolean[] = [];
  valueForCountry: any;
  locationSearch = GlobalConstants.ACTIVE_USRS_LOCATION;
  retailUserId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  locationValueCopy: any;
  retailHQValueCopy: any;
  valueForRetailHq: string;
  validator: boolean;
  searchClose: boolean;
  allRetailHqData: RetailHq[] = [];
  allCountriesName = [];
  allCountries = [] as any;
  hoverValueForRetailHQ: string;
  hovervalueForCountry: string;
  editStoreData = [] as any;
  finalName: string;
  storeNameChangeValue: string;
  custStoreIdChangeValue: string;
  storeNumberChangeValue: string;
  stateRegionCahngeValue: string;
  addressChangeValue: string;
  postalCodeChangeValue: string;
  isStoreNameUnique: boolean;
  downloadFile = new Date().toLocaleDateString() + '_' + GlobalConstants.USERS_STORES_CSV_FILENAME_TEMPLATE + '.csv';
  // invite user popup values
  userEmailAddresses = [];
  isEmailValid: boolean;
  isEmailrequired: boolean;
  invitedEmailString: string;
  inviteUserForm: FormGroup;
  showInvitePopup: boolean;
  showsuccessInvitePopup: boolean;
  PAT_EMAIL = IPOSValidator.EMAIL;
  firstname = sessionStorage.getItem('firstname');
  lastName = sessionStorage.getItem('lastname');
  maxSize = 5;
  retailHQDropdownSelectedValue: string;
  stateDropdownSelectedValue: string;
  countriesDropdownSelectedValue: string;
  retailhqFilterName = ActiveUserConstants.RETAILHQ_VALUE_FILTER;
  stateFilterName = ActiveUserConstants.STATE_FILTER;
  countryFilterName = ActiveUserConstants.COUNTRY_FILTER;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHQ = ActiveUserConstants.REGIONAL_USER_ROLE;
  errorMessage: {};
  allStorescsvData = [];
  UserID: string;
  filtercsvdata: [];
  checkEmailValue: string;
  checkDuplicate: boolean;
  userEmails: [];
  checkEdit: boolean;
  storesInvite: string;
  locationListObj = [];
  columnOneLocationList = [];
  columnTwoLocationList = [];
  columnThreeLocationList = [];
  locationListColumnOne = [];
  locationListColumnTwo = [];
  locationListColumnThree = [];
  isExpanded: boolean;
  usersData: ActiveUsers[] = [];
  editTooltip = GlobalConstants.EDIT;
  inviteTooltip = GlobalConstants.INVITE_USER;
  loggedInUser: boolean;
  checkRegistered: boolean;
  checkDuplicateCount: number;
  countryValue: string;
  paginationCount: number;
  totalPages: number;
  searchQueue = {};
  sortQueue = {};
  buttonShow: boolean[] = [];
  noRecordFound = GlobalConstants.NO_RECORDS_FOUND;
  searchPlaceholderText = $localize`:@@stores.input-placeholder.search:Search...`;
  storeNamePlaceholderText = $localize`:@@stores.store-user.store-name:Store Name`;
  storeNumberPlaceholderText = $localize`:@@stores.store-user.store-number:Store Number`;
  customerIdPlaceholderText = $localize`:@@stores.store-user.custom-store-id:Custom Store ID`;
  stateProviceRegionPlaceholderText = $localize`:@@stores.store-user.state-province-region:State/Province/Region`;
  addressPlaceholderText = $localize`:@@stores.store-user.address:Address`;
  postalCodePlaceholderText = $localize`:@@stores.store-user.postal-code:Postal Code`;
  createdByName: string;
  languageCode: string;
  nameVal = StoresConstant.NAME_VALUE;
  locationVal = StoresConstant.COUNTRY_VALUE;
  retailHQVal = ActiveUserConstants.RETAILHQ_VALUE;
  customStoreIDVal = ActiveUserConstants.CUSTOM_STOREID_VALUE;
  uploadCSVNote = GlobalConstants.UPLOAD_CSV_NOTE;
  uploadedCSVError = GlobalConstants.UPLOAD_CSV_ERROR;
  uploadedCSVGeneralError = GlobalConstants.GENERIC_ERROR_MSG_UPLOAD_CSV;
  showRetailGif = false;
  selectedLangEng: boolean;
  deleteTooltipLabel = GlobalConstants.DELETE;
  multiSelectClicked: boolean = false;
  selectedStores = {};
  selectAll: number = 0;
  contentName: string;
  selectedStoresData: any = {};
  isStoreAssociated: boolean;
  checkUncheckFlag: boolean = false;
  selectDeSelectAllFlag: boolean = false;
  isStoreModified = false;
  isStoreNameDuplicateError = false;
  isGerman = localStorage.getItem('preferredLanguage') === 'de';
  isUkraine = localStorage.getItem('preferredLanguage') === 'uk';
  tempSelectStoreData: any;
  private ngUnsubscribe = new Subject();
    constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private storesService: StoresService,
    private formBuilder: FormBuilder,
    private retailHqService: RetailService,
    private activeUserService: ActiveusersService,
    private cmnService: CommonService
  ) { }

  ngOnInit(): void {
    this.languageCode = (localStorage.getItem('preferredLanguage')) ? localStorage.getItem('preferredLanguage') : '';
    this.page = 1;
    this.tableSize = 10;
    this.showFrom = (this.page - 1) * this.tableSize + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.storesInvite = ActiveUserConstants.PLACEHOLDER_STORES_INVITE;
    this.getAllActiveUsers();
    this.file = {};
    this.document = document;
    this.showCreatePopup = false;
    this.searchClose = false;
    this.showStoresContainer = true;
    this.filterString = '';
    this.closeFilter = false;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.valueForSearch = StoresConstant.NAME_VALUE;
    this.valueForRetailHq = null;
    this.locationValueCopy = null;
    this.createFormGroupvaluesforStore();
    this.createFormGroupvaluesforinvite();
    this.showInvitePopup = false;
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.showsuccessInvitePopup = false;
    this.loggedInUser = true;
    this.globalSortBy = StoresConstant.CREATED_TIME;
    this.globalSortValue = StoresConstant.DESCENDING_ORDER;
    this.getAllStoresByUserID();
    this.createdByName = this.firstname + ' ' + this.lastName
    this.isExpanded = false;
    this.getAllLocationList();
    this.retailerID = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.showRetailGif = data;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createFormGroupvaluesforStore() {
    this.storeForm = this.formBuilder.group({
      storeName: new FormControl(''),
      retailerName: new FormControl(''),
      storeNumber: new FormControl(''),
      customStoreId: new FormControl(''),
      countryName: new FormControl(''),
      regionName: new FormControl(''),
      addressValue: new FormControl(''),
      postalCode: new FormControl('', [Validators.pattern(/^[A-z\p{L}0-9]+(?:[-]{0,1}[A-z\p{L}0-9]+)*$/)])
    });
  }

  getAllStoresByUserID(filterString?: string) {
    this.storesService
      .getAllStoresbyUserID(this.globalSortBy, this.globalSortValue, this.page, filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllStoresResponse => {
        this.expanded = [];
        this.buttonShow = [];
       this.storesData = getAllStoresResponse.store as Stores[];
        this.paginationCount = (getAllStoresResponse.paginationContext.totalItems);
        this.totalPages = (getAllStoresResponse.paginationContext.totalPages);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        this.countryList = getAllStoresResponse.locationList || [];
        this.countryList.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
        this.hqRetailer = getAllStoresResponse.retailerNameList || [];
        this.hqRetailer.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
        this.stateProvinceRegions = getAllStoresResponse.stateProvinceList || [];
        this.stateProvinceRegions.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
        if (this.storesData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        } else if (this.loggedInUser) {
          this.stateProvinceRegions =
            [...new Set(getAllStoresResponse.stateProvinceList?.map(stateProvinceList => stateProvinceList))];
          this.stateProvinceRegions.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
          this.countryList = [...new Set(getAllStoresResponse.locationList?.map(locationList => locationList))];
          this.countryList.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
          this.hqRetailer = [...new Set(getAllStoresResponse.retailerNameList?.map(retailerNameList => retailerNameList))];
          this.hqRetailer.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
        }
        this.isStoresTableEmpty = (this.storesData?.length === 0) || false;
        this.cmnService.setRetailGifValue(false);
      },
        error => {
          this.isStoresTableEmpty = true;
        });
  }

  getStoresbyID(index) {
    this.isStoreNameUnique = false;
    this.buttonShow[index] = !this.buttonShow[index];
    this.expanded[index] = !this.expanded[index];
    if (!this.expanded[index]) {
      this.isEditable[index] = false;
      this.showEditSave[index] = false;
    }
  }
  compareStrings(a, b) {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();

    return (a < b) ? -1 : (a > b) ? 1 : 0;
  }
  createNewStores() {
    this.showCreatePopup = true;
    this.storeName = '';
    this.locationValueCopy = null;
    this.valueForCountry = null;
    this.allCountries = countryConstants;
    if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === ActiveUserConstants.REGIONAL_USER_ROLE) {
      this.retailerID = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
      this.retailerName = sessionStorage.getItem(GlobalConstants.RETAILER_NAME);
      this.valueForRetailHq = sessionStorage.getItem(GlobalConstants.RETAILER_NAME);
      if (this.valueForRetailHq.length > 18) {
        this.valueForRetailHq = this.valueForRetailHq.substring(0, 18) + StoresConstant.DOTS;
      }
    }
    this.retailHqService.getAllRetailerInfo(StoresConstant.CREATED_TIME, RetailStoreCommonConstants.DESCENDING_ORDER)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        result.retailer.sort(function (a, b) {
          a = a?.retailerName ? a.retailerName.toLowerCase() : 'z';
          b = b?.retailerName ? b.retailerName.toLowerCase() : 'z';

          return a < b ? -1 : a > b ? 1 : 0;
        });
        this.allRetailHqData = (result.retailer as RetailHq[]);
      });
    this.validator = this.storeForm.controls.storeName.value && this.retailerName && this.country ? true : false;
    this.hovervalueForCountry = StoresConstant.COUNTRY_VALUE;
    this.hoverValueForRetailHQ = RetailStoreCommonConstants.RETAILHQ_VALUE;
  }

  onCreateStore() {
    const storesContent: StoresInterface = {
      storeName: this.storeForm.controls.storeName.value.trim(),
      retailerName: this.retailerName,
      storeNumber: this.storeForm.controls.storeNumber.value,
      customStoreID: this.storeForm.controls.customStoreId.value,
      country: this.locationValueCopy ? this.locationValueCopy.nameInEng : '',
      stateRegionProvince: this.storeForm.controls.regionName.value,
      address: this.storeForm.controls.addressValue.value,
      postalCode: this.storeForm.controls.postalCode.value,
      createdByUserID: StoresConstant.EMPTY_VALUE,
      createdByName: this.createdByName
    };
    // TODO: unsubscribe
    this.storesService.createNewStore(storesContent, this.retailerID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getResponseAfterCreate => {
        if (getResponseAfterCreate.responseContext.success) {
          setTimeout(_ => { this.getAllStoresByUserID(this.filterString); }, 2000);
          this.showCreatePopup = false;
          this.valueForRetailHq = null;
          this.retailHQValueCopy = null;
          this.locationValueCopy = null;
          this.storeForm.reset();
          this.searchClose = false;
          this.searchData = '';
          this.page = 1;
        }
        this.cmnService.setRetailGifValue(false);
        this.cmnService.setPackageStatus(true);
      },
        (err) => {
          if (!err.responseContext.success && err.responseContext.exceptionResponse.errorMessage === 'UniquesStoreName') {
            this.isStoreNameUnique = true;
          }
        }
      );

    window['dataLayer'].push({
      'new_store_added': true
    });
  }

  onSelectChange(value) {
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = StoresConstant.STORE_NAME_SEARCH;
      this.valueForSearch = StoresConstant.NAME_VALUE;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = StoresConstant.RETAILER_NAME_SEARCH;
      this.valueForSearch = RetailStoreCommonConstants.RETAILHQ_VALUE;
    } else if (value === Enumvalues.VALUE_3) {
      this.searchTag = StoresConstant.COUNTRY_SEARCH;
      this.valueForSearch = StoresConstant.COUNTRY_VALUE;
    }
    else if (value === Enumvalues.VALUE_4) {
      this.searchTag = StoresConstant.CUSTOM_STORE_SEARCH;
      this.valueForSearch = StoresConstant.CUSTOM_STORE_VALUE; 
    }    
    this.selectAll = 0;
    this.checkUncheck();
  }

  onTableDataChange(event) {
    this.page = event;
    this.getAllStoresByUserID(this.filterString);
  }

  sort(sortKey: string) {
    switch (sortKey) {
      case StoresConstant.STORE_CODE: {
        this.sortingTableWithAscandDesc(StoresConstant.STORECODE_SORT);
        break;
      }
      case StoresConstant.STORE_NAME: {
        this.sortingTableWithAscandDesc(StoresConstant.STORENAME_SORT);
        break;
      }
      case StoresConstant.CUSTSTORE_ID: {
        this.sortingTableWithAscandDesc(StoresConstant.CUSTSTOREID_SORT);
        break;
      }
      case StoresConstant.COUNTRY: {
        this.sortingTableWithAscandDesc(StoresConstant.COUNTRY_SORT);
        break;
      }
      case StoresConstant.REGION: {
        this.sortingTableWithAscandDesc(StoresConstant.REGION_SORT);
        break;
      }
      case StoresConstant.ADDRESS: {
        this.sortingTableWithAscandDesc(StoresConstant.ADDRESS_SORT);
        break;
      }
      case StoresConstant.POSTAL_CODE: {
        this.sortingTableWithAscandDesc(StoresConstant.POSTALCODE_SORT);
        break;
      }
      case StoresConstant.STORE_NUMBER: {
        this.sortingTableWithAscandDesc(StoresConstant.STORENUMBER_SORT);
        break;
      }
      default:
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    this.isAscendingSort = !this.isAscendingSort;
    this.globalSortValue = this.isAscendingSort
      ? StoresConstant.ASCENDING_ORDER
      : StoresConstant.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    this.getFilterSearchData();
  }

  onClose() {
    this.showCreatePopup = false;
    this.storeForm.reset();
    this.locationValueCopy = null;
    this.valueForCountry = null;
    this.allCountries = [];
    this.valueForRetailHq = null;
  }

  onRetailChange(retValue) {
    if (retValue) {
      this.retailHQValueCopy = retValue;
      this.retailerID = retValue.retailerId;
      this.retailerName = retValue.retailerName;
      this.valueForRetailHq = this.retailerName;
      this.hoverValueForRetailHQ = this.valueForRetailHq;
      if (this.retailHQValueCopy?.retailerName.length > 17) {
        this.retailHQValueCopy.retailerName =
          this.retailHQValueCopy?.retailerName.substring(0, 17) + StoresConstant.DOTS;
      }
      if (
        this.storeName &&
        this.retailHQValueCopy?.retailerName !== RetailStoreCommonConstants.RETAILHQ_VALUE &&
        this.locationValueCopy !== null
      ) {
        this.validator = true;
      } else {
        this.validator = false;
      }
    } else {
      this.validator = false;
    }
  }

  getEditableData(index: number, rowData): any {
    this.isStoreNameUnique = false;
    this.createdBy = rowData.createdByName;
    this.showEditSave[index] = true;
    this.expanded[index] = true;
    if (!this.expanded[index]) {
      this.showEditSave[index] = false;
    }
    this.isEditable[index] = true;
  }

  editStore(editData, index) {
    this.isStoreNameUnique = false;
    editData.storeName = editData.storeName.trim();
    this.buttonShow[index] = false;
    this.storesService.editStore(editData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(editResponse => {
        if (editResponse) {
          this.expanded[index] = false;
          this.showEditSave[index] = false;
          this.isEditable[index] = false;
          setTimeout(() => {
            this.getAllStoresByUserID(this.filterString);
          }, 1500);
          this.cmnService.setPackageStatus(true);
        }
      },        
      error => {
            this.isStoreNameUnique = true;
          });
  }

  onCountryChange(countryData) {
    this.locationValueCopy = countryData;
    if (this.storeName?.trim().length !== 0 && this.valueForRetailHq &&
      this.locationValueCopy !== null && this.locationValueCopy !== undefined) {
      this.hovervalueForCountry = countryData;
      this.validator = true;
      if (this.locationValueCopy.CountryName.length > 18) {
        this.locationValueCopy.CountryName =
          this.locationValueCopy.CountryName.substring(0, 18)
          + StoresConstant.DOTS;
      }
      else {
        if (this.locationValueCopy.CountryName.length > 17) {
          this.locationValueCopy.CountryName =
            this.locationValueCopy.CountryName.substring(0, 17)
            + StoresConstant.DOTS;
        }
      }
    } else {
      this.validator = false;
    }
  }

  batchCreate() {
    this.openModal = !this.openModal;
  }

  CloseBatchadd() {
    this.openModal = false;
    this.file = {};
    this.finalName = '';
    this.incorrectError = false;
    this.isStoreModified = false;
    this.importdata = {};
    this.showcsvError = false;
    this.isStoreNameDuplicateError = false;
  }

  onFilechange(fileInput: any) {
    this.incorrectError = false;
    this.isStoreModified = false;
    this.fileName = fileInput.target.files[0].name;
    const fileType = this.fileName.split('.')
      .pop();
    if (this.fileName.length > 30) {
      const flname = this.fileName.substring(0, 30);
      this.finalName = `${flname}...${fileType}`;
    } else {
      this.finalName = this.fileName;
    }
    if ((fileType || '').toLowerCase() !== GlobalConstants.FILE_TYPE_CSV) {
      this.showcsvError = true;
      return;
    } else {
      this.showcsvError = false;
    }
    this.file = fileInput.target.files[0];
    const reader = new FileReader();
    reader.readAsText(this.file, GlobalConstants.ENCODING_TYPE);
    reader.onload = _event => {
      this.checkDuplicateStoreName(reader.result);
    };
    fileInput.target.value = null;
  }

  closeSuccesspopup() {
    this.successPopup = false;
    this.CloseBatchadd();
  }

  uploadFile() {
    const input = new FormData();
    input.append('file', this.file);
    // TODO: unsubscribe
    if (this.userRole === this.intelAdmin) {
      this.storesService
        .createBatchAdd(input)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          data => {
            this.importdata = data;
            if (data?.responseContext?.success === true) {
              if (data?.store?.length === 0 || data?.store === undefined) {
                this.isStoreModified = true;
              } else {
                this.storeCount = data?.store?.length;
                this.googleAnalyticsService.bulkUploadStore(data?.store?.length);
                this.incorrectError = false;
                this.openModal = false;
                this.successPopup = true;
                this.isStoreModified = false;
                // TODO After confirming success popup
                // setTimeout(() => {
                //   this.successPopup = false;
                // }, 2000);
                setTimeout(_ => { this.getAllStoresByUserID(); }, 2000);
                this.cmnService.setPackageStatus(true);
              } this.finalName = '';
            }
            // TODO: unsubscribe
          },
          (err) => {
            this.incorrectError = true;
            this.errorMessage = err.missingFields;
          }
        );
    }

    if (this.userRole === this.retailHqUser || this.userRole === this.regionalHQ) {
      this.storesService
        .createBatchAddByRetailHq(input, sessionStorage.getItem(this.globalConst.RETAILER_ID), sessionStorage.getItem(this.globalConst.RETAILER_NAME))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          data => {
            this.importdata = data;
            if (data?.responseContext?.success === true) {
              if (data?.store?.length === 0 || data?.store === undefined) {
                this.isStoreModified = true;
              } else {
                this.storeCount = data?.store?.length;
                this.googleAnalyticsService.bulkUploadStore(data?.store?.length);
                this.incorrectError = false;
                this.openModal = false;
                this.successPopup = true;
                this.isStoreModified = false;
                // TODO After confirming success popup
                // setTimeout(() => {
                //   this.successPopup = false;
                // }, 2000);
                setTimeout(_ => { this.getAllStoresByUserID(); }, 2000);
              } this.finalName = '';
            }
            // TODO: unsubscribe
          },
          (err) => {
            this.incorrectError = true;
            this.errorMessage = err.missingFields;
          }
        );
    }
  }

  checkDuplicateStoreName(data) {
    let csvArray = data.split('\n');
    let csvJsonObj = [];
    let csvData = [];
    //HEADERS/Columns from CSV

    const storesHeadersObj = {
      storeHeaders: []
    };
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_STORENAME);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_LOCATION);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_RETAILHQNAME);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_RETAILHQID);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_STORENUMBER);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_CUSTOMSTOREID);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_SPR);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_ADDRESS);
    storesHeadersObj.storeHeaders.push(GlobalConstants.STORES_CSV_POSTALCODE);

    let csvHeaders = storesHeadersObj.storeHeaders;

    for (let i = 1; i < csvArray.length; i++) {
      csvData = csvArray[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/g);
      let csvObj = {};
      for (let j = 0; j < csvData.length; j++) {
        csvObj[csvHeaders[j]?.trim()] = csvData[j].trim();
      }
      csvJsonObj.push(csvObj);
    }
    let duplicateStoreName = [];
    let csvJsonObj1 = csvJsonObj.map(item => { return item.storeName });
    csvJsonObj1.forEach((item, val) => {
      const isDuplicate = csvJsonObj1.indexOf(item) != val ? true : false;
      if (isDuplicate) {
        duplicateStoreName.push(item);
      }
    });
    this.isStoreNameDuplicateError = duplicateStoreName.length > 0 ? true : false;
  }

  onStoreNameType(typedName) {
    this.isStoreNameUnique = false;
    if (
      typedName && typedName?.trim().length !== 0 &&
      this.valueForRetailHq &&
      this.locationValueCopy !== null
    ) {
      this.validator = true;
    } else {
      this.validator = false;
    }
  }

  createFormGroupvaluesforinvite() {
    this.inviteUserForm = this.formBuilder.group({
      emailAddress: new FormControl('')
    });
  }

  inviteStoreUser(data) {
    this.checkEdit = false;
    this.storeName = data.storeName;
    this.retailerID = data.retailerId;
    this.retailerName = data.retailerName;
    this.storeId = data.storeId;
    this.country = data.country;
    this.showInvitePopup = true;
  }

  onInviteStore() {
    this.isEmailValid = true;
    this.checkEmailRequied();
    if (this.isEmailrequired) {
      if (this.userEmailAddresses?.length <= 0) {
        this.checkEmailvaild();
      }
      if (!this.checkDuplicate && this.isEmailValid && !this.checkRegistered) {
        const inviteContent: UserRole = {
          email:
            this.userEmailAddresses?.length <= 1
              ? this.inviteUserForm.get('emailAddress').value
                ? this.inviteUserForm.get('emailAddress').value
                : this.userEmailAddresses[0]
              : this.userEmailAddresses.toString(),
          role: 'storeUser',
          retailerName: this.retailerName,
          retailerID: this.retailerID,
          storeID: this.storeId,
          storeName: this.storeName,
          location: this.country,
          createdByUserID: sessionStorage.getItem('userId'),
          createdByName: this.firstname + ' ' + this.lastName
        };
        this.storesService
          .inviteStoreUser(inviteContent)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(data => {
            if (data.responseContext.success === true) {
              this.showInvitePopup = false;
              this.invitedEmailString = this.userEmailAddresses?.length > 1 ? this.userEmailAddresses?.length +
                ' users' : (this.inviteUserForm.get('emailAddress').value ? this.inviteUserForm.get('emailAddress').value :
                  this.userEmailAddresses[0]);
              this.showsuccessInvitePopup = true;
              this.userEmailAddresses = [];
              this.locationValueCopy = null;
              this.valueForCountry = null;
              this.inviteUserForm.reset();
            }
          });
      }
    }
  }

  onCloseInvite() {
    this.checkDuplicate = false;
    this.showInvitePopup = false;
    this.inviteUserForm.reset();
    this.storeName = '';
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.userEmailAddresses = [];
    this.checkDuplicateCount = 0;
  }

  onCloseSuccessPopup() {
    this.invitedEmailString = '';
    this.storeName = '';
    this.showsuccessInvitePopup = false;
  }

  addEmail() {
    this.isEditable = undefined;
    this.checkEdit = false;
    this.checkEmailRequied();
    if (this.isEmailrequired) {
      this.checkEmailvaild();
      this.checkDuplicateCount = 0;
      const emailExists = this.usersData.find(resp => resp.email === this.inviteUserForm.get('emailAddress').value.replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      if (this.userEmailAddresses.length > 0) {
        if (this.userEmailAddresses.includes(this.inviteUserForm.get('emailAddress').value
          .replace(/\n/ig, ''))) {
          this.checkDuplicate = true;
        } else {
          this.checkDuplicate = false;
        }
      }
      if (this.isEmailValid && !this.checkDuplicate && !this.checkRegistered) {
        this.userEmailAddresses.push(this.inviteUserForm.get('emailAddress').value
          .trim()
          .replace(/\s/g, ''));
        this.inviteUserForm.controls.emailAddress.reset();
      }
    }
  }

  onKeyUp(event) {
    if (event.key === 'Enter') {
      this.addEmail();
    } else if (event.key === ',' || event.key === ';') {
      this.checkEmailRequied();
      if (this.isEmailrequired) {
        const re = this.PAT_EMAIL;
        this.isEmailValid = re.test(this.inviteUserForm.get('emailAddress').value
          .slice(0, -1)
          .trim());
        if (this.isEmailValid) {
          this.userEmailAddresses.push(this.inviteUserForm.get('emailAddress').value
            .slice(0, -1)
            .trim());
          this.inviteUserForm.controls.emailAddress.reset();
        }
      }
    } else if ((event.key === 'Backspace') || (event.key === 'Delete')) {
      const emailExists = this.usersData.find(resp => resp.email === this.inviteUserForm.get('emailAddress').value.replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      this.isEmailValid = true;
      this.checkDuplicate = false;
      this.checkEmailRequied();
      if (this.isEmailrequired) {
        this.checkEmailvaild();
      }
    }
  }

  deleteEmail(indexval: number) {
    if (indexval > -1) {
      this.userEmailAddresses.splice(indexval, 1);
    }
    if (this.userEmailAddresses.includes(this.inviteUserForm.get('emailAddress').value
      .replace(/\n/ig, ''))) {
      this.checkDuplicate = true;
    } else {
      this.checkDuplicate = false;
    }
  }

  checkEmailvaild() {
    const re = this.PAT_EMAIL;
    this.isEmailValid = re.test(
      this.inviteUserForm.get('emailAddress').value
        .trim()
        .replace(/[\r\n]+/gm, '')
    );
  }

  checkEmailRequied() {
    this.isEmailrequired = this.userEmailAddresses?.length || this.inviteUserForm.get('emailAddress').value;
  }

  addBorder(wrap: HTMLElement) {
    wrap.classList.add('onfocus-border');
  }

  removeBorder(wrap: HTMLElement) {
    wrap.classList.remove('onfocus-border');
  }

  filter(keyname: string, data: string) {
    this.closeFilter = true;
    switch (keyname) {
      case ActiveUserConstants.RETAILHQ_VALUE_FILTER:
        this.retailHQDropdownSelectedValue = data;
        break;
      case ActiveUserConstants.STATE_FILTER:
        this.stateDropdownSelectedValue = data;
        break;
      case ActiveUserConstants.COUNTRY_FILTER:
        this.countriesDropdownSelectedValue = data;
        break;
      default:
        this.selectFilterQueue = {};

        return;
    }
    this.selectFilterQueue[keyname] = data;
    this.getFilterSearchData();
    this.page = 1;
    this.selectedStores = {};// Reset filters
    this.selectAll = 0;
    this.checkUncheck();
  }

  clearFilter(filterName?: string) {
    if (filterName && filterName === ActiveUserConstants.RETAILHQ_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.retailHQDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === ActiveUserConstants.STATE_FILTER) {
      delete this.selectFilterQueue[filterName];
      // this.stateProvinceRegions = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.stateDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === ActiveUserConstants.COUNTRY_FILTER) {
      delete this.selectFilterQueue[filterName];
      // this.countryList = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.countriesDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else {
      // set selected filters string to blank
      this.filterString = '';
      this.selectFilterQueue = {};
      this.getAllStoresByUserID();
      this.getFilterSearchData();
      this.closeFilter = false;
      this.countryList = null;
      this.hqRetailer = null;
      this.stateProvinceRegions = null;
      this.retailHQDropdownSelectedValue = '';
      this.stateDropdownSelectedValue = '';
      this.countriesDropdownSelectedValue = '';
      this.searchClose = false;
      this.searchData = '';
      this.page = 1;
    }
    this.selectedStores = {};// Reset filters
    this.selectAll = 0;
    this.checkUncheck();
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.filterString = '';
      this.searchQueue = {};
      this.getFilterSearchData();
      this.searchData = '';
      this.showFrom = this.page = 1;
      this.showTo = 10;
    }
  }

  onBackSpaceClear(event) {
    if (!this.searchData.length && event) {
      this.searchClose = false;
    }
  }

  cancelEdit(id: string, cancelIndex) {
    const index = this.storesData.findIndex(ele => ele.storeId === id);
    if (index > -1) {
      this.expanded[index] = false;
      this.showEditSave[index] = false;
    }
    this.buttonShow[cancelIndex] = false;
    this.searchClose = false;
    // this.countryList = null;
    // this.hqRetailer = null;
    // this.stateProvinceRegions = null;
    // this.retailHQDropdownSelectedValue = '';
    // this.stateDropdownSelectedValue = '';
    // this.countriesDropdownSelectedValue = '';
    // this.getAllStoresByUserID();
    this.searchData = '';
    this.page = 1;
  }

  onTypeSearch(value) {
    if (value !== StoresConstant.EMPTY_VALUE) {
      this.searchClose = true;
    }
  }

  GetFormattedDate() {
    var todayTime = new Date();
    var month = ('0' + (todayTime.getMonth() + 1)).slice(-2);
    var day = ('0' + todayTime.getDate()).slice(-2);
    var year = todayTime.getFullYear();
    var filename = "Stores_";
    return filename + day + month + year;
  }

  downloadCsvFile() {
    this.UserID = sessionStorage.getItem('userId');

    if (navigator.onLine) {
      const storesrequestBody = {
        "csvHeaders": [
          GlobalConstants.USERS_STORES_STORE_NAME,
          GlobalConstants.ACTIVE_USRS_LOCATION,
          GlobalConstants.ACTIVE_USRS_RETAIL_HQ_NAME,
          GlobalConstants.USERS_STORES_RETL_HQ_ID,
          GlobalConstants.USERS_STORES_STORE_NUM,
          GlobalConstants.ACTIVE_USRS_CUST_ID,
          GlobalConstants.USERS_STORES_STATE,
          GlobalConstants.USERS_STORES_ADDR,
          GlobalConstants.USERS_STORES_PSTL_CODE,
          GlobalConstants.ACTIVE_USRS_CREATED_BY
        ]
      };
      if (this.filterString) {
        if (this.userRole === this.intelAdmin) {
          this.storesService
            .postdownloadcsvStoresbyFilter(this.filterString, storesrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllStoresResponse => {
              this.downloadCsv(getAllStoresResponse);
            });
        }
        else if (this.userRole === this.retailHqUser || this.userRole === this.regionalHQ) {
          this.storesService
            .postdownloadcsvStoresbyFilterRetailHq(this.filterString, storesrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllStoresRetailUsersFilterResponse => {
              this.downloadCsv(getAllStoresRetailUsersFilterResponse);
            });
        }
        else {
          // TODO
        }
      } else {
        if (this.userRole === this.intelAdmin) {
          this.storesService.postAllStoresForCsv(this.UserID, storesrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllUsersResponse => {
              this.downloadCsv(getAllUsersResponse);
            });
        }
        else if (this.userRole === this.retailHqUser || this.userRole === this.regionalHQ) {
          this.storesService.postAllStoresForCsvRetailHq(this.UserID, storesrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllStoresRetailUsersResponse => {
              this.downloadCsv(getAllStoresRetailUsersResponse);
            });
        }
        else {
          // TODO
        }
      }
    } else {
      // TODO
    }
  }

  downloadCsv(csvResponse) {
    this.allStorescsvData = csvResponse;
    let todayTime = new Date();
    let month = ('0' + (todayTime.getMonth() + 1)).slice(-2);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.USERS_STORES_CSV_FILENAME;
    let userfilename = filename + '_' + day + month + year;
    const blob = new Blob(['\ufeff' + this.allStorescsvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  getAllActiveUsers() {
    this.searchClose = false;
    this.activeUserService.getAllUsersData()
      .subscribe(getFilterUsersResponse => {
        this.usersData = (getFilterUsersResponse.user as ActiveUsers[]);
      });
  }

  onPaste(event) {
    event.preventDefault();
    this.checkDuplicateCount = 0;
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    this.userEmails = pastedText.split(/,|;/);
    this.userEmails.forEach(val => {
      if (!val) {
        return;
      }
      const re = this.PAT_EMAIL;
      this.isEmailValid = re.test(val);
      const emailExists = this.usersData.find(resp => resp.email === val);
      if (emailExists) {
        this.checkRegistered = emailExists ? true : false;
        this.inviteUserForm.patchValue({ emailAddress: val });
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
      }
      if (this.isEmailValid && this.userEmailAddresses.indexOf(val) === -1 && !this.checkRegistered) {
        this.userEmailAddresses.push(val);
      }
    });
  }

  editEmail(event) {
    if (this.checkEdit) {
      return false;
    }
    this.checkEdit = true;
    const emailValue = this.userEmailAddresses[event];
    this.isEditable = event;
    this.userEmailAddresses.splice(event, 1);
    this.inviteUserForm.patchValue({ emailAddress: emailValue });
  }

  avoidSpecialChar(event) {
    event.target.value = event.target.value.replace(IPOSValidator.SPECIAL_CHARS, '');
    event.target.value = event.target.value
      .replace(/\.+/g, '.')
      .replace(/_+/g, '_')
      .replace(/-+/g, '-')
      .replace(/@+/g, '@');
    event.target.value = event.target.value
      .replace(/^\./g, '')
      .replace(/^_/g, '')
      .replace(/^-/g, '')
      .replace(/^@/g, '');
    event.target.value = event.target.value
      .replace(/@\./g, '@')
      .replace(/@_/g, '@')
      .replace(/@-/g, '@');
    event.target.value = event.target.value.replace(
      IPOSValidator.AVOID_CONSECUTIVE,
      '$1');
  }

  returnDefault() {
    return 0;
  }

  searchActiveUsers(searchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = StoresConstant.STORE_NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      // un comment if you need to pass all search param
      this.searchQueue = {};
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
    } else {
      this.getAllStoresByUserID();
      this.page = 1;
    }
  }

  searchtheUserssonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchActiveUsers(searchData);
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllStoresByUserID(this.filterString);
    } else {
      this.getAllStoresByUserID();
    }
    //this.selectedStores = {};// Reset filters
    this.selectAll = 0;
    this.checkUncheck();
  }

  getAllLocationList() {
    this.selectedLangEng = localStorage.getItem(this.globalConst.PREFERRED_LANGUAGE) == this.globalConst.LANGUAGE_ENGLISH ? true : false;
    if (this.selectedLangEng) {
      storesCountriesConstants.forEach(element => {
        let list;
        if (element.order >= 'A' && element.order <= 'F') {
          this.columnOneLocationList.push({
            name: element.name,
            order: element.order
          });
          list = this.columnOneLocationList;
          const groups = this.setLocationListGrouping(list);
          this.locationListColumnOne = Object.keys(groups).map(function (key) {
            return { order: key, name: groups[key] };
          });
        } else if (element.order >= 'G' && element.order <= 'N') {
          this.columnTwoLocationList.push({
            name: element.name,
            order: element.order
          });
          list = this.columnTwoLocationList;
          const groups = this.setLocationListGrouping(list);
          this.locationListColumnTwo = Object.keys(groups).map(function (key) {
            return { order: key, name: groups[key] };
          });
        } else {
          this.columnThreeLocationList.push({
            name: element.name,
            order: element.order
          });
          list = this.columnThreeLocationList;
          const groups = this.setLocationListGrouping(list);
          this.locationListColumnThree = Object.keys(groups).map(function (key) {
            return { order: key, name: groups[key] };
          });
        }
      });
    } else {
      storesCountriesConstants.forEach(element => {
        let list;
        if (element.order >= 'A' && element.order <= 'G') {
          this.columnOneLocationList.push({
            name: element.name,
            order: element.order,
            eName: element.eName
          });
          const groups = this.setLocationListGrouping(this.columnOneLocationList);
          const eNameGroups = this.setLocationListGrouping(this.columnOneLocationList, true);
          this.locationListColumnOne = Object.keys(groups).map(function (key) {
            return { order: key, name: groups[key], eName: eNameGroups[key] };
          });
        } else {
          this.columnTwoLocationList.push({
            name: element.name,
            order: element.order,
            eName: element.eName
          });
          list = this.columnTwoLocationList;
          const groups = this.setLocationListGrouping(list);
          const eNameGroups = this.setLocationListGrouping(this.columnTwoLocationList, true);
          this.locationListColumnTwo = Object.keys(groups).map(function (key) {
            return { order: key, name: groups[key], eName: eNameGroups[key] };
          });
        }
      });
    }
  }
  getTranslatedLoc(name: string) {
    const countryTranslated = countryConstants?.find(i=> i?.nameInEng === name );
    this.filterCountryList = name;
    return ( countryTranslated?.CountryName || name );
  }

  getLocationList() {
    this.isExpanded = !this.isExpanded;
  }

  setLocationListGrouping(list, eNameFlag?) {
    let groups = list.reduce(function (obj, item) {
      obj[item.order] = obj[item.order] || [];
      if (eNameFlag) {
        obj[item.order].push(item.eName);
      } else {
        obj[item.order].push(item.name);
      }

      return obj;
    }, {});

    return groups;
  }

  downloadTemplate() {

    let headers = {
      [GlobalConstants.USERS_STORES_STORE_NAME]: '',
      [GlobalConstants.ACTIVE_USRS_LOCATION]: '',
      [GlobalConstants.ACTIVE_USRS_RETAIL_HQ_NAME]: '',
      [GlobalConstants.USERS_STORES_RETL_HQ_ID]: '',
      [GlobalConstants.USERS_STORES_STORE_NUM]: '',
      [GlobalConstants.ACTIVE_USRS_CUST_ID]: '',
      [GlobalConstants.USERS_STORES_STATE]: '',
      [GlobalConstants.USERS_STORES_ADDR]: '',
      [GlobalConstants.USERS_STORES_PSTL_CODE]: '',
    };
    let tempHeaders = Object.keys(headers).join(',');
    let todayTime = new Date();
    let month = ('0' + (todayTime.getMonth() + 1)).slice(-2);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.USERS_STORES_CSV_FILENAME;
    let userfilename = filename + '_' + day + month + year;
    const blob = new Blob(['\ufeff' + tempHeaders], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);

  }

  countrySearchFn(term: string, item: any) {
    return item?.CountryName.toLocaleLowerCase()?.startsWith(term?.toLocaleLowerCase());
  }
  //IIT2-5498
  retailerSearchFn(term: string, item: any) {
    return item?.retailerName?.toLocaleLowerCase()?.startsWith(term?.toLocaleLowerCase());
  }
  // IIT2-7833 Starts
  openDeleteModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openStoreDeletePopup(storeData): any {
    this.storeName = storeData.storeName;
    this.storeId = storeData.storeId;
    const storeDeleteData = {
      stores: [this.storeId]
    }
    this.storesService.deleteStoresByStoreIds(JSON.stringify(storeDeleteData))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe((deleteStoreResponse) => {
        if (deleteStoreResponse) {
          this.openDeleteModal(this.deleteModal);
          const storeResponse = deleteStoreResponse.storeAssociatedResponse;
          this.isStoreAssociated = (storeResponse.assetExistence || storeResponse.deviceExistence || storeResponse.profileExistence || storeResponse.userExistence) ? true : false;
        }
      })
  }

  deleteIndividualStore(storeId) {
    const storeDeleteData = {
      stores: [storeId],
      confirmDelete: true
    }
    this.storesService.confirmDeleteStoresByIds(JSON.stringify(storeDeleteData))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(() => {
        this.isStoresTableEmpty = (this.storesData?.length === 0) || false;
        this.closeModal(this.deleteModal);
        this.openDeleteModal(this.deleteAckModal);
        this.googleAnalyticsService.deleteStore(1,storeId);
        setTimeout(_ => { this.getAllStoresByUserID(this.filterString); }, 3000);
      },
        error => {
          this.isStoresTableEmpty = true;
          this.closeModal(this.deleteModal);
          this.closeModal(this.deleteAckModal);
        });
    // IIT2-7833 Ends
    if (this.userRole?.toLowerCase()?.includes(GlobalConstants.ADMIN)) {
      this.googleAnalyticsService.storeDeletedbyAdmin(GlobalConstants.SINGLE_STORE_DELETED);
    }
    else if (this.userRole?.toLowerCase()?.includes(this.globalConst.RETAILHQ)) {
      this.googleAnalyticsService.storeDeletedByRatailHQ(GlobalConstants.SINGLE_STORE_DELETED);
    }
  }

  //For multiselect
  EnableDeleteMultipleStores() {
    this.multiSelectClicked = true;
    this.selectedStores = {};
  }

  //select all Stores
  selectDeSelectAll(event, type, storeId?, data?) {
    let userSelcted = event?.target?.checked; 
    if (type === this.globalConst.ALL_TEXT) {
      if (!this.retailHQDropdownSelectedValue && this.userRole == this.intelAdmin) {
        event.target.checked = false;
        return false;
      } else {
        this.selectedStores = {};
        this.storesService
          .getAllStoresbyUserID(this.globalSortBy, this.globalSortValue, undefined, this.filterString, this.retailUserId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(storesResponse => {
            let stores = storesResponse?.store as Stores[];
            this.selectAll = stores?.length;
            for (let i = 0; i < stores?.length; i++) {
              this.selectedStores[stores[i].storeId] = userSelcted;
            }
            this.checkUncheck();
          });
      }
    } else {
      if(data){
        this.tempSelectStoreData = data;
      }
      this.selectedStores[storeId] = userSelcted;
      this.checkUncheck();
    }
  }

  //To Cancel multiselect
  cancelMultiSelect() {
    this.multiSelectClicked = false;
    this.selectAll = 0;
    this.selectedStores = {};
    this.checkUncheck();
  }

  //ToShowDelPopup
  showMultiStoreDelPopup() {
    this.selectedStoresData = { stores: [] };
    for (let i in this.selectedStores) {
      if (this.selectedStores[i]) {
        this.selectedStoresData.stores.push(i);
      }
    }
    if(this.selectedStoresData.stores?.length === 1){
      for(let i=0;i<this.storesData?.length;i++){
        if(this.selectedStoresData.stores[0] === this.storesData[i]?.storeId){
          this.tempSelectStoreData = this.storesData[i];
        }
      }
      this.openStoreDeletePopup(this.tempSelectStoreData);
    }else if(this.selectedStoresData.stores?.length >1){
      //API call to validate the stores data
      this.storesService.deleteStoresByStoreIds(this.selectedStoresData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((responseData) => {
          this.openDeleteModal(this.deleteMultiStoreModal);
          let len = this.selectedStoresData?.stores?.length;
          this.contentName = this.globalConst.STRONG;
          this.contentName += (len <= 10) ? this.cmnService.convertNumberToWords(len) : len;
          this.contentName += this.globalConst.STRONG_CLOSE;
          this.contentName += " " + (len === 1 ? this.globalConst.MULTI_STORE_DELETE_BODY_TEXT1_SINGLE : this.globalConst.MULTI_STORE_DELETE_BODY_TEXT1);
          if (responseData?.storeAssociatedResponse?.assetExistence === this.globalConst.YES_TEXT ||
            responseData?.storeAssociatedResponse?.deviceExistence === this.globalConst.YES_TEXT ||
            responseData?.storeAssociatedResponse?.profileExistence === this.globalConst.YES_TEXT ||
            responseData?.storeAssociatedResponse?.userExistence === this.globalConst.YES_TEXT) {
            this.contentName += " " + this.globalConst.MULTI_STORE_DELETE_BODY_TEXT2;
          }
        })
    }
  }

  //After confirmation - function to call delete API 
  deleteMultiStore() {
    this.selectedStoresData.confirmDelete = true;
    this.closeModal(this.deleteMultiStoreModal);
    this.storesService.confirmDeleteStoresByIds(this.selectedStoresData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe((responseData) => {
        this.googleAnalyticsService.deleteStore(this.selectedStoresData.stores.length, this.selectedStoresData.stores);
        this.openDeleteModal(this.deleteMultiAckModal);
        setTimeout(_ => { this.getAllStoresByUserID(this.filterString); }, 3000);
      });
    if (this.userRole?.toLowerCase()?.includes(GlobalConstants.ADMIN)) {
      this.googleAnalyticsService.storeDeletedbyAdmin(GlobalConstants.MULTI_STORES_DELETED);
    }
    else if (this.userRole?.toLowerCase()?.includes(GlobalConstants.RETAILHQ)) {
      this.googleAnalyticsService.storeDeletedByRatailHQ(GlobalConstants.MULTI_STORES_DELETED);
    }
  }

  //To refresh the content when close triggered in acknowledgement.
  closeTriggered() {
    // this.clearFilter(); // to Remove if any filters selected previously and refresh the dataset.
    this.cancelMultiSelect();
  }
  //To engable/ disable Delete selected btn
  checkDisable(forSelectAll?) {
    let checkArr = [];
    for (let i in this.selectedStores) {
      if (this.selectedStores[i]) {
        checkArr.push(i);
      }
    }
    if (forSelectAll) {
      return checkArr?.length;
    } else {
      if (checkArr?.length) {
        return false;
      } else return true;
    }
  }
  //To reset/set check/uncheck for select/Unselect All. IIT2-6284
  checkUncheck() {
    let selectedCount = this.checkDisable(1);
    this.checkUncheckFlag = (selectedCount > 0 || this.selectAll > 0) ? (this.selectAll === selectedCount ? true : false) : false;
    if(this.paginationCount === selectedCount) {
      this.selectDeSelectAllFlag = true;
    } else {
      this.selectDeSelectAllFlag = false;
    }
  }
}
